import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../img/niranlogo.png";
import downArrow from "../icons/down-arrow.png";
import { useSelector, useDispatch } from "react-redux";
import { fetchUser } from "../redux/authSlice";
import { fetchUserNotifications, markNotification } from "../redux/shortListSlice";
import userAvatar from "../img/user-avatar.png"; 
import { logout } from "../redux/authSlice";
import { useTranslation } from "react-i18next";


const getPath = (link) => `/${link.link}`;

/* ─────────────────────────────────────────
   NOTIFICATION BELL COMPONENT
───────────────────────────────────────── */
const SAMPLE_NOTIFICATIONS = [
  {
    id: 1,
    text: "Kavitha Ramesh showed interest in your profile.",
    time: "2 min ago",
    read: false,
  },
  {
    id: 2,
    text: "Your profile was shortlisted by Priya Murugan.",
    time: "1 hr ago",
    read: false,
  },
  {
    id: 3,
    text: "New match suggestion: Ananya Kumar — 91% Match.",
    time: "3 hr ago",
    read: true,
  },
  {
    id: 4,
    text: "Divya Suresh accepted your interest request.",
    time: "Yesterday",
    read: true,
  },
];

function NotificationBell({ notifications: initialNotifications, dispatch }) {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const popupRef = useRef(null);
  const unreadCount = notifications.filter((n) => n.isRead === false).length;

useEffect(() => {
  const userAuthToken = localStorage.getItem("token");
  if (initialNotifications?.notifications && userAuthToken) {
    setNotifications(initialNotifications.notifications);
  }else {
    setNotifications([]);
  }
}, [initialNotifications]);
  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const markAllRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
  };

  const markOne = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, isRead: true } : n)),
    );
  };

  // read notfications api call
  const readNotification = (id) => {
    // Call API to mark as read
    console.log("Marking notification as read:", id);
    if (id) {
      dispatch(markNotification(id));
      dispatch(fetchUserNotifications());
    }
  }

  return (
    <div className="notif-wrapper" ref={popupRef}>
      <button
        className="notif-bell-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label="Notifications"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {unreadCount > 0 && (
          <span className="notif-badge">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div className="notif-popup">
          <div className="notif-popup-header">
            <span className="notif-popup-title">Notifications</span>
            {unreadCount > 0 && (
              <button className="notif-mark-all" onClick={markAllRead}>
                {/* Mark all read */}
              </button>
            )}
          </div>
           
          <div className="notif-list">
            {notifications.length === 0 ? (
              <div className="notif-empty">
                <span>🔔</span>
                <p>No notifications yet</p>
              </div>
            ) : (
              notifications.map((n) => (
                <div
                  key={n.id}
                  className={`notif-item ${n.isRead ? "notif-item--read" : "notif-item--unread"}`}
                  onClick={() => markOne(n.id)}
                >
                  <div className="notif-item-dot" />
                  <div className="notif-item-content" onClick={() => readNotification(n.id)}>
                    <p className="notif-item-text">{n.message}</p>
                    <span className="notif-item-time">{n.timeAgo}</span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────
   HEADER (unchanged except NotificationBell added)
───────────────────────────────────────── */
export default function Header() {

  const [langOpen, setLangOpen] = useState(false);
const [profileOpen, setProfileOpen] = useState(false);

   const languages = [
    { code: "en", label: "English" },
    { code: "ta", label: "தமிழ்" },
  ];
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
const NAV_LINKS = [
  { name: t("home"), link: "home" },
  { name: t("matches"), link: "matches" },
  { name: t("interest"), link: "interest" },
  { name: t("success_stories"), link: "successstories" },
  { name: t("about"), link: "about" },
  { name: t("contact"), link: "contact" },
  { name: t("pricing"), link: "pricing" },
];

const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
  localStorage.setItem("lang", lang);
};
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profile, setProfile] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const storeNotifications = useSelector((state) => state.shortList?.notifications || []);
  
  const [user, setUser] = useState(() => {
  try {
    const stored = localStorage.getItem("user");

    if (!stored || stored === "undefined") {
      return null;
    }

    return JSON.parse(stored);
  } catch (error) {
    console.error("Invalid JSON in localStorage:", error);
    return null;
  }
});
  const dispatch = useDispatch();

  const userFromStore = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(fetchUser());
    const interval = setInterval(() => {
      if(localStorage.getItem("token")){
    dispatch(fetchUserNotifications());
      }
  }, 30000); // 30 seconds

  return () => clearInterval(interval); // ✅ cleanup
  }, [dispatch]);

  useEffect(() => {
    console.log("Notifications in header:", storeNotifications);
    setNotifications(storeNotifications);
  }, [storeNotifications]);

useEffect(() => {
  const loadUser = () => {
    try {
      const stored = localStorage.getItem("user");

      if (!stored || stored === "undefined") {
        setUser(null);
        return;
      }

      setUser(JSON.parse(stored));
    } catch (err) {
      console.error("Invalid JSON in localStorage:", err);
      setUser(null);
    }
  };

  loadUser();
  window.addEventListener("focus", loadUser);

  return () => window.removeEventListener("focus", loadUser);
}, []);
  useEffect(() => {
    console.log("userFromStore in header:", userFromStore);
    if (userFromStore?.profile) {
      setProfile(userFromStore.profile);
    }
  }, [userFromStore]);

  useEffect(() => {
    if (profile?.photos?.length) {
      const primary = profile.photos.find((p) => p.isPrimary);
      setProfileImage(primary?.url || profile.photos[0]?.url);
    }
  }, [profile]);

  const displayName =
    profile?.userId?.userName ||
    userFromStore?.username ||
    userFromStore?.name ||
    user?.username ||
    user?.name ||
    "User";

  const handleLogout = () => {
    localStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
    dispatch(logout());
    navigate("/login");
  };

  return (
    <>
<header className="niran-header" data-lang={i18n.language}>   
       <div className="niran-header__inner">
          <div className="niran-header__logo">
            <img 
            src={logo} 
            alt="Niranmatrimony Logo" 
            onError={(e)=>{
              e.target.onerror = null;
              e.target.src = userAvatar;
            }}
            />
          </div>

          <nav>
            <ul className="niran-header__nav">
              {NAV_LINKS.map((link) => (
                <li key={link.name}>
                  <Link
                    to={getPath(link)}
                    className={
                      location.pathname === getPath(link) ? "active" : ""
                    }
                  >
                    {link.name}
                  </Link>{" "}
                </li>
              ))}
            </ul>
          </nav>

          <div className="niran-header__actions">
            <div className="language-switcher">
                <div className="lang-select-wrap">
  <i className="ti ti-world lang-icon" />
  
  <div className="custom-dropdown">
      <div
        className="dropdown-selected"
        onClick={() => setLangOpen(!langOpen)}
      >
        {languages.find((lang) => lang.code === i18n.language)?.label || "English"}

        {changeLanguage}
        <img src={downArrow} alt="dropdown" className={`dropdown-arrow ${langOpen  ? "rotate" : ""}`}/> 
     </div>

      {langOpen && (
        <div className="dropdown-options">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className="dropdown-option"
              onClick={() => {
                changeLanguage(lang.code);
                setLangOpen(false);
              }}
            >
              {lang.label}
            </div>
          ))}
        </div>
      )}
    </div>

</div>
          </div>
            {/* ── Notification Bell ── */}
            <NotificationBell notifications={storeNotifications} dispatch={dispatch} />

            {user ? (
              <div className={`profile-menu ${profileOpen ? "open" : ""}`}>
                <div
                  className="niran-header__username"
                  onClick={() => setProfileOpen(!profileOpen)}
                >
                  <span>{displayName}</span>
                  {profileImage ? (
                    <img
                      className="profile-img"
                      src={`${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileImage}`}
                      alt="profile"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = userAvatar;
                      }}
                    />
                  ) : (
                    <div
                      className="profile-img"
                      style={{
                        background: "#e9d5ff",
                        borderRadius: "50%",
                        width: 36,
                        height: 36,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                        color: "#7c3aed",
                        fontSize: 14,
                      }}
                    >
                      {displayName?.[0]?.toUpperCase() || "U"}
                    </div>
                  )}
                  <img src={downArrow} alt="arrow" className="down-arrow" />
                </div>

                {profileOpen && (
                  <div className="dropdown-menu">
                    {user?.role !== "admin" && (
                    <div
                      className="dropdown-item"
                      onClick={() => navigate("/dashboard")}
                    >
                      {t("profile_edit_btn")}
                    </div>
                    )}
                    {user?.role === "admin" && (
                      <div
                        className="dropdown-item"
                        onClick={() => navigate("/create-profile")}
                      >
                        Profiles
                      </div>
                    )}
                    <div
                      className="dropdown-item"
                      onClick={() => navigate("/shortlisted")}
                    >
                      {t("profile_shortlist_btn")}
                    </div>

                    <div className="dropdown-item" onClick={handleLogout}>
                      {t("logout")}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                <button
                  className="niran-header__login"
                  onClick={() => navigate("/login")}
                >
                 {t("login")}
                </button>
                <button
                  className="niran-header__signup"
                  onClick={() => navigate("/register")}
                >
                  {t("signup")}
                </button>
              </>
            )}
          </div>

          <button
            className={`niran-header__hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu">
            <span />
            <span />
            <span />
          </button>
        </div>

        <div className={`niran-header__mobile-menu ${menuOpen ? "open" : ""}`}>
          <ul>
            {NAV_LINKS.map((link) => (
              <li key={link.name}>
                <Link to={getPath(link)} onClick={() => setMenuOpen(false)}>
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </header>
    </>
  );
}
